<script setup>
import LogoAdvup from 'dashboard/components-next/marca/LogoAdvup.vue';

defineProps({
  message: {
    type: String,
    required: true,
  },
  // Os atalhos só fazem sentido quando há conversa para escolher.
  mostrarAtalhos: {
    type: Boolean,
    default: false,
  },
});

// Os atalhos da lista (useChatListKeyboardEvents): nomes de tecla não se
// traduzem.
const ATALHOS = [
  { teclas: ['Alt', 'J'], chave: 'PREVIOUS' },
  { teclas: ['Alt', 'K'], chave: 'NEXT' },
];
</script>

<template>
  <div class="esm">
    <LogoAdvup altura="min(15rem, 38vh)" />
    <p class="esm__frase">{{ message }}</p>
    <p v-if="mostrarAtalhos" class="esm__atalhos">
      <span v-for="atalho in ATALHOS" :key="atalho.chave" class="esm__tecla">
        <kbd v-for="tecla in atalho.teclas" :key="tecla">{{ tecla }}</kbd>
        {{
          atalho.chave === 'PREVIOUS'
            ? $t('CONVERSATION.EMPTY_STATE.PREVIOUS')
            : $t('CONVERSATION.EMPTY_STATE.NEXT')
        }}
      </span>
    </p>
  </div>
</template>

<style scoped>
/* A tela da conversa quando nenhuma está aberta: a logo vetorial da casa montando-se,
   a frase do que fazer e os atalhos para andar pela lista. */
.esm {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--esp-3);
  height: 100%;
  padding: var(--esp-6);
  text-align: center;
}

.esm__frase {
  max-width: 26rem;
  margin: 0;
  font-size: var(--txt-bloco);
  font-weight: var(--peso-forte);
  line-height: var(--linha-normal);
  color: rgb(var(--slate-12));
  animation: advupPop var(--mov-4) var(--mov-curva) backwards;
  animation-delay: var(--mov-2);
}

.esm__atalhos {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--esp-3);
  margin: 0;
  animation: advupPop var(--mov-4) var(--mov-curva) backwards;
  animation-delay: var(--mov-3);
}

.esm__tecla {
  display: inline-flex;
  align-items: center;
  gap: var(--esp-1);
  font-size: var(--txt-nota);
  color: rgb(var(--slate-11));
}

.esm__tecla kbd {
  display: inline-grid;
  place-items: center;
  min-width: 22px;
  height: 22px;
  padding: 0 var(--esp-1);
  border: 1px solid rgb(var(--slate-5));
  border-bottom-width: 2px;
  border-radius: var(--r-2);
  background: rgb(var(--solid-1));
  font-family: inherit;
  font-size: var(--txt-rotulo);
  font-weight: var(--peso-forte);
  color: rgb(var(--slate-12));
}

@media (prefers-reduced-motion: reduce) {
  .esm__frase,
  .esm__atalhos {
    animation: none;
  }
}

@media (max-width: 639px) {
  .esm__atalhos {
    display: none;
  }
}
</style>
